import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-4">
      <div className="container mx-auto">
        <p className="text-center">© 2024 Kinza Ali. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
